import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.url),
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('../components/TaxiFlows.vue')
    }
  ]
})

export default router
